import * as Vue from "vue"
import App from "./App.vue";

const app = Vue.createApp(App);
app.mount('#app');